<template>
  <div class="notification-badge" v-if="count > 0" :class="badgeClasses">
    {{ count }}
  </div>
</template>

<script setup>
import { computed } from 'vue';

const props = defineProps({
  count: {
    type: Number,
    default: 0
  },
  animated: {
    type: Boolean,
    default: true
  }
});

// Computed-Property für dynamische Klassen
const badgeClasses = computed(() => ({
  'animate-pulse': props.animated
}));
</script>

<style scoped>
.notification-badge {
  position: absolute;
  top: -8px;
  right: -8px;
  background-color: #dc2626; /* Rot-600 */
  color: white;
  border-radius: 50%;
  min-width: 20px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  font-weight: bold;
  padding: 0 4px;
}

@keyframes pulse {
  0%, 100% {
    opacity: 1;
  }
  50% {
    opacity: 0.7;
  }
}

.animate-pulse {
  animation: pulse 1.5s cubic-bezier(0.4, 0, 0.6, 1) infinite;
}
</style> 